import { CustomNextImage as Image } from '@crehana/next';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { css } from 'styled-components';

import useFormStepsContext from '../../hooks/useFormStepsContext';
import {
  WrapperChatTips,
  WrapperChatTipsImages,
  WrapperChatTipsSubtitle,
} from './ChatTips.styles';

const ChatTips = () => {
  const { titleByStep } = useFormStepsContext();

  return (
    <WrapperChatTips className="flex justify-between m-auto">
      <div className="w-1/4">
        <WrapperChatTipsImages className="rounded-full relative overflow-hidden">
          <Image
            src="https://crehana-public-catalog.imgix.net/images/app/gallery/2022/04/07/8f198ff5/fd933f30.png"
            alt="consultant"
            layout="fill"
            objectFit="cover"
            objectPosition="center"
            quality={100}
          />
        </WrapperChatTipsImages>
      </div>
      <div className="w-3/4">
        <div
          className="px-12 py-24 sm:p-24 bg-evelate-dark-04dp"
          css={css`
            border-radius: 0px 20px 20px 20px;
            height: fit-content;
          `}
        >
          <span className="font-poppins text-16 font-normal sm:hidden text-white">
            {titleByStep.title}
          </span>
          <span className="font-poppins text-16 font-normal hidden sm:block text-white">
            {titleByStep.title}
          </span>
        </div>
        {titleByStep.subTitle && (
          <WrapperChatTipsSubtitle className="px-16 py-8 sm:px-32 flex justify-between items-center mt-16 bg-evelate-dark-04dp text-white">
            <>
              <span className="font-poppins text-16 font-normal  sm:hidden">
                {titleByStep.subTitle}
              </span>
              <span className="font-poppins text-16 font-normal  hidden sm:block">
                {titleByStep.subTitle}
              </span>
            </>
          </WrapperChatTipsSubtitle>
        )}
      </div>
    </WrapperChatTips>
  );
};

export default ChatTips;
